import React, { useEffect, useRef } from "react";

export default function NFTFireCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d", { alpha: true });

    let w = 0;
    let h = 0;
    let particles = [];
    let raf;

    const random = (min, max) => Math.random() * (max - min) + min;

    const resize = () => {
      const rect = canvas.getBoundingClientRect();
      w = canvas.width = rect.width * window.devicePixelRatio;
      h = canvas.height = rect.height * window.devicePixelRatio;
      ctx.setTransform(window.devicePixelRatio, 0, 0, window.devicePixelRatio, 0, 0);

      particles = Array.from({ length: 120 }, createParticle);
    };

    const createParticle = () => {
      const cw = canvas.clientWidth;
      const ch = canvas.clientHeight;

      return {
        x: cw / 2 + random(-108, 108),
        y: ch * 0.72 + random(0, 35),
        vx: random(-0.8, 0.8),
        vy: random(-2.8, -0.8),
        // r: random(10, 32),
        r: random(15, 48),
        life: random(35, 80),
        maxLife: 80,
        alpha: random(0.45, 1),
      };
    };

    const draw = () => {
      const cw = canvas.clientWidth;
      const ch = canvas.clientHeight;

      ctx.clearRect(0, 0, cw, ch);
      ctx.globalCompositeOperation = "lighter";

      // 底部主火焰光
      const glow = ctx.createRadialGradient(
        cw / 2,
        ch * 0.72,
        0,
        cw / 2,
        ch * 0.72,
        120
      );
      glow.addColorStop(0, "rgba(255,230,120,0.9)");
      glow.addColorStop(0.25, "rgba(255,120,0,0.65)");
      glow.addColorStop(0.65, "rgba(255,40,0,0.22)");
      glow.addColorStop(1, "rgba(255,40,0,0)");

      ctx.fillStyle = glow;
      ctx.fillRect(0, 0, cw, ch);

      particles.forEach((p, i) => {
        p.x += p.vx;
        p.y += p.vy;
        p.life--;

        const t = p.life / p.maxLife;
        const r = Math.max(p.r * t, 0);

        const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, r);
        g.addColorStop(0, `rgba(255,250,180,${p.alpha})`);
        g.addColorStop(0.35, `rgba(255,130,0,${p.alpha * 0.75})`);
        g.addColorStop(1, "rgba(255,40,0,0)");

        ctx.beginPath();
        ctx.arc(p.x, p.y, r, 0, Math.PI * 2);
        ctx.fillStyle = g;
        ctx.fill();

        if (p.life <= 0 || r <= 1) {
          particles[i] = createParticle();
        }
      });

      ctx.globalCompositeOperation = "source-over";
      raf = requestAnimationFrame(draw);
    };

    resize();
    draw();

    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute left-0 top-0 z-0 w-full h-full pointer-events-none"
    />
  );
}